import { CommonOperators, Operator } from '../Condition';
import ConditionProperty from '../conditionProperty/ConditionProperty';
import ConditionVisibleControls from "../conditionProperty/ConditionVisibleControls";

export default class WindowProperty extends ConditionProperty {
  static override readonly label: string = 'Window Property';
  static override readonly formFields: ConditionVisibleControls = { fieldName: true, fieldPath: true, fieldIndex: false };
  static override readonly type: number = 6;

  static override showPath(operator: number): boolean {
    return operator === Operator.CONTAIN_PROPERTY_TYPE;
  }

  showPath(): boolean {
    return WindowProperty.showPath(this.condition.operator);
  }

  buildDescription(): string {
    const { path, name } = this.condition.options;
    const withPath = this.showPath() ? ` with [${path}]` : '';
    return `window.[${name}] ${this.getOperatorLabel()}${withPath}: [${this.condition.value}]`;
  }

  override getOperators(): Array<Operator> {
    return [ ...CommonOperators,
      { type: Operator.CONTAIN_PROPERTY_TYPE, label: 'array does not contain object', negative: true },
    ];
  }
}
